import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-brand-main px-4 pb-16 pt-10 text-center md:pb-20 md:pt-12" data-id="element-279">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.58
    }} className="mx-auto max-w-4xl" data-id="element-280">
        <h1 className="mx-auto max-w-2xl text-4xl font-black leading-[1.06] tracking-tight sm:text-5xl md:text-6xl" data-id="element-281">
          Solve a Full Year of Art Class in Just{' '}
          <span className="italic text-brand-red" data-id="element-282">5 Minutes</span>
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-283">
          Join 2,000+ art teachers who stopped improvising. Walk into every
          class with everything ready to teach, create, and inspire.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/siwbqGMK1nyJeqmhUMNSjE/ChatGPT_Image_12_jul_2026,_12_13_16-Photoroom.png" alt="Art Ready digital art curriculum collection for teachers" className="mx-auto mt-4 h-[17rem] w-auto max-w-full object-contain sm:h-80 md:h-[26rem]" data-id="element-284" />
        <div className="mt-4" data-id="element-285">
          <CTAButton className="px-7 py-3.5 text-xs md:px-8 md:py-4 md:text-sm" data-id="element-286">
            GET THE ART READY PACK
          </CTAButton>
          <p className="mt-3 text-[11px] font-semibold text-brand-gray md:text-xs" data-id="element-287">
            Instant Download <span className="px-1 text-brand-orange" data-id="element-288">·</span>{' '}
            No Subscription <span className="px-1 text-brand-orange" data-id="element-289">·</span>{' '}
            Lifetime Access <span className="px-1 text-brand-orange" data-id="element-290">·</span>{' '}
            7-Day Guarantee
          </p>
        </div>
      </motion.div>
    </section>;
}